import React from "react";
import { Drawer, Button } from "antd";
import parse from "html-react-parser";
import { spaceBeforeCapital } from "../../utils";
import docs_img from "../../assests/images/google-docs.png";

const NotificationDrawer = ({
  item,
  open,
  setOpen,
  //notificationCreateView = false,
}) => {
  const handleMessage = (item) =>
    item?.channels?.[0]?.channelType
      ? item?.channels?.[0]?.message
      : item?.channels?.default?.message;

  const handleTitle = (item) =>
    item?.channels?.[0]?.channelType
      ? item?.channels?.[0]?.title
      : item?.channels?.default?.title;

  return (
    <>
      <Drawer
        title={handleTitle(item)}
        placement="right"
        width={700}
        onClose={() => setOpen(false)}
        open={open}
        className="notification-drawer"
      >
        <p>
          <span
            className="notification-type"
            style={{
              color: "#2E77D0",
              backgroundColor: "#E3EFFE",
              border: "0.5px solid #AFD3FF",
            }}
          >
            {spaceBeforeCapital(item?.eventType)}
          </span>
          <span
            className={`notification-type ml-05 ${
              item?.priority?.toUpperCase() === "HIGH"
                ? "notification-type-high"
                : "notification-type-low"
            }`}
          >
            {spaceBeforeCapital(item?.priority)}
          </span>
          <span className="ml-05">
            {item?.createdAt?.split("T")[0]}{" "}
            {item?.createdAt?.split("T")[1]?.split(".")[0]}
          </span>
        </p>

        <p
          style={{
            marginBottom: 0,
            fontSize: 13,
            color: item.read ? "#838797" : "black",
            width: "300px",
          }}
        >
          {parse(handleMessage(item) || "")}
        </p>
        {item?.channels?.default?.file?.length > 0 && (
          <>
            <p
              style={{
                color: "#2E77D0",
                marginBottom: "5px",
                fontWeight: "600",
              }}
            >
              Attachment shared
            </p>

            <div style={{ marginTop: 8 }}>
              {item.channels.default.file.map((file, index) => (
                <a
                  key={index}
                  href={file?.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    marginRight: 10,
                    backgroundColor: "#ECECEC",
                    display: "inline-block",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    color: "#484A50",
                    marginTop: "10px",
                  }}
                >
                  <img
                    src={docs_img}
                    alt="docs"
                    style={{ width: "20px" }}
                    className="mr-1"
                  />
                  {file?.url?.split("/").pop()}
                </a>
              ))}
            </div>
          </>
        )}
        {/* {item?.channels?.default?.file?.length > 0 && (
          <div style={{ marginTop: 8 }}>
            {item.channels.default.file.map((file, index) => {
              const fileName = file?.url?.split("/").pop();
              const extension = fileName?.split(".").pop()?.toLowerCase();

              const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "webp",
                "bmp",
                "tiff",
                "svg",
                "avif",
                "heic",
              ];

              const isImage = imageExtensions.includes(extension);

              return isImage ? (
                <img
                  key={index}
                  src={file.url}
                  alt={fileName}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "150px",
                    marginTop: "10px",
                    borderRadius: "6px",
                    display: "block",
                  }}
                />
              ) : (
                <a
                  key={index}
                  href={file?.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    marginRight: 10,
                    backgroundColor: "#ECECEC",
                    display: "inline-block",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    color: "#484A50",
                    marginTop: "10px",
                  }}
                >
                  <img
                    src={docs_img}
                    alt="docs"
                    style={{
                      width: "20px",
                      marginRight: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                  {fileName}
                </a>
              );
            })}
          </div>
        )} */}

        {item?.actions?.length > 0 && (
          <div style={{ marginTop: "20px" }} className="flex-end">
            {item.actions.map((actionData, index) => {
              if (actionData?.actionType?.toUpperCase() === "BUTTON") {
                return (
                  <Button
                    key={index}
                    className="save-btn mt-1"
                    onClick={() => window.open(actionData?.url, "_blank")}
                  >
                    {actionData?.title}
                  </Button>
                );
              } else if (actionData?.actionType?.toUpperCase() === "LINK") {
                return (
                  <a
                    key={index}
                    href={actionData?.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "inline-block", marginTop: 4 }}
                  >
                    {actionData?.title}
                  </a>
                );
              }
              return null;
            })}
          </div>
        )}
      </Drawer>
    </>
  );
};

export default NotificationDrawer;
